import { AxiosResponse } from "axios";
import { getAxiosInstance, requestConfig } from "../../http-common";
import { CreateUserRequest } from "../../models/ExcelAddin/CreateUserRequest";
import { UpdateUserRequest } from "../../models/ExcelAddin/UpdateUserRequest";

const RESOURCE_NAME = "ExcelAddinUsers";

const getAll = () : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}`, requestConfig());
};

const update = (id: number, data: UpdateUserRequest) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${id}`, data, requestConfig());
}

const create = (data: CreateUserRequest) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, data, requestConfig());
}

const remove = (id: number) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
}

const UsersService = {
    getAll,
    update,
    create,
    remove
}

export default UsersService;